import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectUserActiveEmployerBusinessId,
  selectUserActiveEmployerInfo,
} from 'store/user/selectors.js/user.selectors';
import { getShadowRecordsByIds } from '../services/getShadowRecordsByIds.service';

export const loadShadowRecordForRecord = createAsyncThunk(
  'shadowData/loadShadowRecordForRecord',
  async (recordId, { getState }) => {
    const state = getState();
    const activeEmployerBusinessId = selectUserActiveEmployerBusinessId(state);
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    if (!activeEmployerBusinessId || !recordId) {
      return [];
    }

    const shadowRecordId = `${recordId}_${activeEmployerBusinessId}`;
    const shadowRecords = await getShadowRecordsByIds(
      [shadowRecordId],
      activeEmployerInfo
    );

    return shadowRecords;
  }
);
